import SortControl from "./../components/DataTableSortControl";
import * as actions from "./../actions";
import { StoreState } from "./../types/index";
import { connect } from "react-redux";
import { Dispatch } from "redux";

export function mapStateToProps({ query }: StoreState.All) {
  return {
    currentSortField: query.sort.sortField,
    currentSortOrder: query.sort.sortOrder,
  };
}

export function mapDispatchToProps(
  dispatch: Dispatch<actions.AllActions>,
) {
  return {
    toggleSort: (newSortField: string, newSortOrder: string) =>
      dispatch(actions.updateSortOrder(newSortField, newSortOrder)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SortControl);
